<template>
  <div class="flex flex-col md:flex-row md:justify-between">
    <div class="w-64 flex-shrink-0">
      <span class="text-grayDark font-medium mb-2">Cover Image</span>
    </div>
    <div class="md:ml-8 mt-1 md:mt-0 flex-1 flex items-center justify-between">
      <MediaUploadSingle
        entity="guest"
        :working="working"
        :modelId="guest.id"
        :imageUrl="form.coverImageUrl"
        :imageUuid="guest.coverImageUuid"
        :error="uploadingError"
        @uploaded="uploaded"
        @deleted="deleted"
        :cropAspectRatio="218 / 47"
        :minHeight="0"
        :minWidth="0"
        allowedSize="10MB"
        suggestedDimensions="Suggested Dimensions: 285 x 1400"
      />
    </div>
  </div>
</template>

<script>
  import {mapState} from "vuex";
  import MediaUploadSingle from '@/components/shared/MediaUploadSingle';

  export default {
    components: { MediaUploadSingle },

    data() {
      return {
        working: false,
        uploadingError: false,
        form: {
          coverImageUrl: null,
        }
      }
    },

    mounted() {
      this.form.id = this.user.guest.id
      this.form.coverImageUrl = this.user.guest.coverImageUrl
    },

    methods: {
      update() {
        this.working = true
        this.uploadingError = false

        this.$store.dispatch('guest/updateGuest', this.form)
          .then(() => {
            this.working = false
          })
          .catch(() => {
            this.working = false
            this.uploadingError = true
          })
      },

      uploaded(url) {
        this.form.coverImageUrl = url
        this.update()
      },

      deleted() {
        this.form.coverImageUrl = null
      },
    },

    computed: {
      ...mapState({
        guest: state => state.guest.guest,
        user: state => state.auth.user
      }),
    },
  }
</script>